// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3evVy","errorLogs":"styles_errorLogs__3F0Vn"};